import PouchDB from 'pouchdb'
import PouchDBFind from 'pouchdb-find'

PouchDB.plugin(PouchDBFind)

export const productosDB = new PouchDB('practicaja_productos')
export const ventasDB = new PouchDB('practicaja_ventas')
export const clientesDB = new PouchDB('practicaja_clientes')
export const movimientosDB = new PouchDB('practicaja_movimientos')
export const usuariosDB = new PouchDB('practicaja_usuarios')
export const categoriasDB = new PouchDB('practicaja_categorias')
export const configuracionDB = new PouchDB('practicaja_config')

// Crear índices necesarios para búsquedas
async function inicializarDB() {
  try {
    await productosDB.createIndex({ index: { fields: ['nombre', 'categoria'] } })
    await productosDB.createIndex({ index: { fields: ['stock'] } })
    await productosDB.createIndex({ index: { fields: ['codigoBarras'] } })
    await ventasDB.createIndex({ index: { fields: ['fecha'] } })
    await ventasDB.createIndex({ index: { fields: ['clienteId'] } })
    await clientesDB.createIndex({ index: { fields: ['nombre'] } })
  } catch (e) {
    // Los índices ya existen
  }
}

inicializarDB()
